import  {  useRef, useState } from 'react';
import { Button } from '../app/ui/Button';
import Logo from '../../assets/icons/Logo';
import { Input } from '../app/ui/Input';
import { useUser } from 'src/context/UserContext';
import accountApi from '../app/account/AccountApi';
import { setLoggedUserProps } from 'src/util/Util';
import { useHistory } from 'react-router';
import CustomToast from '../app/ui/CustomToast';
import toast from 'react-hot-toast';
const LatestLogin = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const history = useHistory()

  const { setUser } = useUser()
  const [username, 
    setUsername
] = useState('');
  const [password,
    setPassword
] = useState('');

  const [errors, setErrors] = useState<{
    username?: boolean;
    password?: boolean;
  }>({});
  const handleVideoEnded = () => {
    const video = videoRef.current;
    if (!video) return;
    video.currentTime = 3.67;
    video.play();
  };



  const validateForm = () => {
    const newErrors: { username?: boolean; password?: boolean } = {
      username: false,
      password: false,
    };

    if (!username) {
      newErrors.username = true;
    }

    if (!password) {
      newErrors.password = true;
    }

    setErrors(newErrors);

    return newErrors?.username || newErrors?.password;
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsLoading(true)
    if (validateForm()) {
      setIsLoading(false)
          return;
        }
         accountApi.login(username, password).then(async (success) => {
            if (success) {
               await setLoggedUserProps(setUser)
                  history.push('/dashboard')
            } else {
                showErrorToast()
                setIsLoading(false)
            }
        })
    
}

// const showSuccessToast = () => {
//   console.log('hellohellohellohellohellohello')
//   toast.custom((t) => <CustomToast message="Action was successful!" type="success" />,{duration:2000});
// };

const showErrorToast = () => {
  toast.custom((t) => <CustomToast message="Incorrect Username or Password" type="error" />,{duration:2000});
};
  return (
    <section className="relative h-screen bg-[#080808] w-[100%]">
      <video
        onEnded={handleVideoEnded}
        autoPlay={true}
        controls={false}
        muted
        playsInline
        ref={videoRef}
        className="object-cover absolute bottom-0 left-[-20%] w-full h-[60%]  sm:w-3/5 sm:h-full sm:top-0 sm:left-0"
      >
        <source src="/resources/video/hero_video.webm" type="video/webm" />
        <source src="/resources/video/hero_video.mp4" type="video/mp4" />
      </video>

      <div className="relative h-full pt-[35%] max:pt-[40%] sm:pt-0 flex flex-col sm:flex-row sm:items-center sm:justify-center lg:justify-between bg-[transparent]">
        <div className="hidden sm:block sm:w-3/5" />
        <div className="w-full sm:w-2/5 flex flex-col  sm:items-start justify-center lg:pl-10 p-5">
          <div className="grid gap-3 mt-3  lg:text-left">
            <Logo width={112}
              height={24}
              className="hidden sm:block mb-10"/>

            <div className="lg:max-w-[515px] lg:mx-0">
              <h2 className="text-[26.97px] leading-[34px] w-[90%] sm:w-[100%] font-medium tracking-negative-44 md:tracking-negative-64 md:text-[39.44px] md:leading-[44px] uppercase font-unbounded mb-2 ">
                Creating The Future of the Ad Funded Internet
              </h2>
            </div>

            <form
              onSubmit={handleSubmit}
              className="mt-3 grid gap-3 w-full"
              data-testid="modal-id"
            >
              <Input
                type="text"
                label="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="bg-[#2A2A2A]  text-[#A1A1A1] h-[40px] w-full text-[14px] leading-[19.88px] font-normal font-popins"
                errorState={errors?.username}
                // error={errors?.username?"Please input your username!":""}
              />

              <Input
                type="password"
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-[#2A2A2A]  text-[#A1A1A1] h-[40px] w-full"
                errorState={errors?.password}
                // error={errors?.password?"Please input your Password!":""}

              />

              <Button
                className="bg-[#D0D0D0] text-[#0B0B0B] rounded-[40px] w-full h-[40px]"
                type="submit"
                state={isLoading?'loading':'default'}
                disabled={isLoading}
                variant={'primary'}
              >
                Log In
              </Button>
            </form>
          </div>
        </div>
      </div>

    </section>
  );
};

export default LatestLogin;
